import { blockCategories } from '../../../categories';
import accotionsScript from './accotionsScript';

const processedIds = new Set();

const addAccordionComponent = (editor, opts = {}) => {
    const componentType = 'accordion';
    const accordionItemType = 'accordion-item';
    const defaultOpts = {
        animationTime: 300,
        defaultItems: 3,
        expandFirstItem: true,
        allowMultipleItemsOpen: true,
        hideDefaultAccordionStyles: false,
        iconPosition: 'end',
        scrollOnExpand: false,
        animationDuration: 300,
    };

    const options = { ...defaultOpts, ...opts };

    const getAnimationTime = (component, accordionEl) => {
        const traits = component?.get('traits');
        if (traits?.length > 0) {
            const trait = traits.find(
                (t) => t.get('name') === 'data-animation-duration'
            );
            if (trait) {
                const value = parseInt(trait.get('value') || trait.get('default'), 10);
                if (!isNaN(value)) return value;
            }
        }
        const attrValue = accordionEl?.getAttribute('data-animation-duration');
        return attrValue ? parseInt(attrValue, 10) : options.animationDuration;
    };

    const initAccordionScript = (accordionId, component, accordionEl, canvasDoc) => {
        const animationTime = getAnimationTime(component, accordionEl);
        accotionsScript(canvasDoc, {
            id: accordionId,
            animationTime: isNaN(animationTime) ? options.animationTime : animationTime,
        });
    };

    const createAccordionItem = (accordionId, index, isExpanded = false) => {
        const itemId = `acc_${accordionId}_${index}_${Date.now()}_${Math.floor(
            Math.random() * 10000
        )}`;

        return {
            type: accordionItemType,
            components: [
                {
                    name: 'Accordion Header',
                    tagName: 'div',
                    droppable: true,
                    removable: false,
                    draggable: false,
                    copyable: false,
                    selectable: false,
                    attributes: {
                        class: 'card-header',
                        'data-toggle': 'collapse',
                        'data-target': `#${itemId}`,
                        'aria-expanded': isExpanded ? 'true' : 'false',
                    },
                    components: {
                        tagName: 'div',
                        removable: false,
                        draggable: false,
                        copyable: false,
                        droppable: false,
                        selectable: false,
                        attributes: {
                            class: 'accordion-header',
                        },
                        components: [
                            {
                                tagName: 'div',
                                name: 'Accordion Title',
                                attributes: {
                                    class: 'title-container',
                                },
                                removable: false,
                                draggable: false,
                                copyable: false,
                                droppable: true,
                                components: {
                                    type: 'text',
                                    tagName: 'div',
                                    content: 'Accordion title ' + (parseInt(index) + 1),
                                },
                            },
                            {
                                tagName: 'div',
                                removable: false,
                                draggable: false,
                                copyable: false,
                                droppable: false,
                                selectable: false,
                                attributes: {
                                    class: `accordion-icon ${isExpanded ? 'rotate-180' : ''}`,
                                },
                                components: [
                                    {
                                        removable: false,
                                        draggable: false,
                                        copyable: false,
                                        droppable: false,
                                        tagName: 'svg',
                                        type: 'text',
                                        content: `
                                              <svg class="w-7 h-7 transition-transform" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="6 9 12 15 18 9" />
                                              </svg>
                                            `,
                                    },
                                ],
                            },
                        ],
                    },
                },
                {
                    tagName: 'div',
                    name: 'Accordion Body',
                    removable: false,
                    draggable: false,
                    copyable: false,
                    droppable: true,
                    attributes: {
                        id: itemId,
                        class: `acc-collapse ${isExpanded ? 'acc-show' : ''}`,
                        'data-parent': `#${accordionId}`,
                    },
                    components: [
                        {
                            tagName: 'div',
                            attributes: {
                                class: 'accordion-body',
                            },
                        },
                    ],
                },
            ],
        };
    };

    const initAccordionScripts = () => {
        const canvasDoc = editor.Canvas.getDocument();
        if (!canvasDoc) return;

        const accordionComponents = [];



        canvasDoc.querySelectorAll('.accordion.sio-accordion[id]').forEach((accordionEl) => {
            const accordionId = accordionEl.id;
            if (accordionId && !processedIds.has(accordionId)) {
                processedIds.add(accordionId);
                initAccordionScript(accordionId, null, accordionEl, canvasDoc);
            }
        });
    };

    editor.DomComponents.addType(componentType, {
        isComponent: (el) => el.tagName === 'DIV' && el.classList.contains('accordion'),
        model: {
            defaults: {
                tagName: 'div',
                droppable: false,
                attributes: {
                    class: 'accordion sio-accordion',
                    id: `accordion-${Date.now()}-${Math.floor(Math.random() * 100000)}`,
                    'data-accordion': '',
                    'data-allow-multiple-open': options.allowMultipleItemsOpen
                        ? 'true'
                        : 'false',
                    'data-scroll-on-expand': options.scrollOnExpand
                        ? 'true'
                        : 'false',
                    'data-animation-duration': options.animationDuration,
                    'data-icon-position': options.iconPosition,
                },
                traits: [
                    {
                        type: 'checkbox',
                        name: 'expandFirstItem',
                        label: 'Standardmäßig den ersten Eintrag öffnen',
                        valueTrue: 'true',
                        valueFalse: 'false',
                        default: options.expandFirstItem,
                    },
                    {
                        type: 'checkbox',
                        name: 'data-allow-multiple-open',
                        label: 'Mehrere Einträge gleichzeitig öffnen',
                        valueTrue: 'true',
                        valueFalse: 'false',
                        default: options.allowMultipleItemsOpen
                            ? 'true'
                            : 'false',
                    },
                    {
                        type: 'checkbox',
                        name: 'data-scroll-on-expand',
                        label: 'Beim Öffnen zum Eintrag scrollen',
                        valueTrue: 'true',
                        valueFalse: 'false',
                        default: options.scrollOnExpand ? 'true' : 'false',
                    },
                    {
                        type: 'number',
                        name: 'data-animation-duration',
                        label: 'Animationsdauer (ms)',
                        default: options.animationDuration,
                    },
                ],
            },
            init() {
                const accordionId = this.get('attributes').id;
                if (!this.components().length) {
                    for (let i = 0; i < options.defaultItems; i++) {
                        this.append(createAccordionItem(accordionId, i, options.expandFirstItem && i === 0));
                    }
                }
            },
        },
    });

    editor.DomComponents.addType(accordionItemType, {
        isComponent: (el) =>
            el.tagName === 'DIV' && el.classList.contains('one-accordion-body'),
        model: {
            defaults: {
                tagName: 'div',
                attributes: { class: 'one-accordion-body' },
            },
        },
    });

    editor.Commands.add('accordion:add-item', {
        run(editor) {
            const selected = editor.getSelected();
            if (selected?.get('type') !== componentType) return;

            const accordionId = selected.get('attributes').id;
            selected.append(createAccordionItem(accordionId, selected.components().length, false));

            setTimeout(() => {
                const canvasDoc = editor.Canvas.getDocument();
                if (canvasDoc) {
                    initAccordionScript(accordionId, selected, selected.getEl?.(), canvasDoc);
                }
            }, 50);
        },
    });

    editor.Commands.add('accordion:init-scripts', {
        run() {
            initAccordionScripts();
        },
    });

    editor.on('component:selected', (component) => {
        if (component.get('type') !== componentType) return;
        const toolbar = component.get('toolbar') || [];
        if (!toolbar.some((btn) => btn.command === 'accordion:add-item')) {
            component.set('toolbar', [
                ...toolbar,
                {
                    attributes: { class: 'fa fa-plus toolbar-icon', title: 'Add Accordion Item' },
                    command: 'accordion:add-item',
                    label: '',
                },
            ]);
        }
    });

    const delayedInit = () => setTimeout(initAccordionScripts, 100);
    editor.on('storage:end:load', delayedInit);
    editor.on('load', delayedInit);
    editor.on('update:canvas', delayedInit);

    editor.on('component:mount', (component) => {
        let accordionComponent = component;
        if (component.get('type') !== componentType) {
            let parent = component.parent();
            while (parent && parent.get('type') !== componentType) {
                parent = parent.parent();
            }
            if (!parent) return;
            accordionComponent = parent;
        }

        const accordionId = accordionComponent.get('attributes').id;
        const canvasDoc = editor.Canvas.getDocument();
        if (!accordionId || !canvasDoc) return;

        setTimeout(() => {
            initAccordionScript(accordionId, accordionComponent, accordionComponent.getEl?.(), canvasDoc);
        }, 0);
    });

    editor.BlockManager.add('accordion', {
        label: 'Akkordeon',
        category: blockCategories.basic,
        attributes: { class: 'fa fa-list-alt' },
        content: {
            type: componentType,
        },
    });
};

export default addAccordionComponent;
